// #region Cookie Utility Functions

/**
 * Retrieve a cookie value by its key.
 * @param {string} key - The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie if it exists, otherwise null.
 */
const getCookie = key => {
	const b = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
	return b ? b.pop() : null;
};
// #endregion

// #region User Country Functions
/**
 * Retrieve the user's country based on the 'GEO_COUNTRY' cookie.
 * @returns {string|null} The value of the 'GEO_COUNTRY' cookie if it exists, otherwise null.
 */
export function getUserCountryBasedOnGeo() {
	const cookie = getCookie('GEO_COUNTRY');
	return cookie || null;
}
// #endregion
